import config from 'config'
import { DEFAULT_PORTAL_CONFIGURATION } from 'services/default-portal-configuration'

export const assetUrlFor = (portalConfiguration, key) => {
  let path = portalConfiguration[key]

  if (portalConfiguration.isDefaultConfiguration || !path) return DEFAULT_PORTAL_CONFIGURATION[key]
  if (!path.match(/^(http|https):\/\//i) && !path.match(/^data\:image/i)) path = config.require('ASSETS_URL') + path

  return path
}
